// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2KkcW","paramInput":"JobSimulator_paramInput__1ixpZ","input":"JobSimulator_input__15Ejz"};